import {
    LoginByMd5MutationVariables,
    LoginMd5Input,
    LoginResult,
} from '../generated/graphql';
import { SDK } from '../index';
import { ResultSuccess } from '../types';

export const loginByMD5 = async (
    data: LoginMd5Input,
    sdk: SDK,
): Promise<LoginResult | ResultSuccess> => {
    const mutation = require('../graphql/mutations/loginByMD5.mutation.gql');
    return sdk.mutate<
        {
            loginByMD5: LoginResult;
        },
        LoginByMd5MutationVariables
    >(
        {
            mutation: mutation,
            variables: { l_Data: data },
        },
        'loginByMD5',
    );
};
